import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Skeleton,
  Stack,
  TextField,
  Typography,
  useMediaQuery
} from "@mui/material";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useTheme } from "@mui/material/styles";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { BIBlue, BILightGrey, BILightYellow, BIRed } from "../../assets/helpers";
import { useNavigate } from "react-router-dom";
import CampaignIcon from "@mui/icons-material/Campaign";
import moment from "moment";
import {
  setBuilderBucksCount,
  setChatCount,
  setDashboardData,
  setMainNotification,
  setSelectedcompany,
  setSelectedSiteId,
  setShowalert,
  setShowmapmodal,
  setShowReport,
  setSurveyLaterToday
} from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import { Getrequestcall } from "../../request/Getrequest";
import {
  FETCH_ADS,
  FETCH_DASHBOARD_DATA,
  FETCH_GOALS,
  GET_SURVEY_DATE,
  GET_TIMESHEETGOAL_DETAIL,
  RAG_ASK,
  RAG_SAVE_CHATBOT_HISTORY_ID_DETAILS,
  SAVE_POST_PICTURE,
  SAVE_POSTS,
  SITE_ACTIVE,
  USER_REWARD_AMOUNT
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import SurveyModal from "../survey/SurveyModal";
import SurveyQuizModal from "../survey/SurveyQuizModal";
import ProgressBar from "../home/ProgressBar";
import Getcurrentlocation from "../common/Getcurrentlocation";
import AddIcon from "@mui/icons-material/Add";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import mapMarkerYellow from "../../assets/images/marker_yellow.png";
import {
  buildIdInfoCardSkeleton,
  expensesCardSkeleton,
  questionsSkeleton,
  SiteCardSkeleton,
  timesheetCardSkeleton,
  userInfoCardSkeleton
} from "../skeleton/SkeletonView";
import PostComment from "../new-community/PostComment";
import Addexpenses from "../expenses/Addexpenses";
import ViewExpenses from "../expenses/ViewExpenses";
import Questions from "../rewards-store/Quistions";
import CloseIcon from "@mui/icons-material/Close";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import placeholder_img from "../../assets/images/placeholder_img.jpg";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import AddWebsiteModal from "../common/AddWebsiteModal";
import AddDescription from "../sites/AddDescription";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import Pages from "../../constant/ReportModel";
import AdsCarousel from "./AdsCarousel";
import { AdsCarouselSkeleton } from "./skeleton/SkeletonView";
import Fade from "@mui/material/Fade";
// Timesheet Components (using the refactored versions)
import AddEditTimesheetModel from "../timesheets/AddEditTimesheetModel";
import TimesheetViewModal from "../timesheets/models/TimesheetViewModal";
import SendTimesheet from "../timesheets/models/SendTimesheet";
import AddClockIn from "../timesheets/models/AddClockIn";
import Joblist from "../timesheets/Joblist";
import PictureViewer from "../common/PictureViewer";
import AdContainer from "../common/AdContainer";
import SendIcon from "@mui/icons-material/Send";
import ChatIcon from "@mui/icons-material/Chat";
import Chatbot from "./Chatbot";
import SmartToyIcon from "@mui/icons-material/SmartToy";

const Home = () => {
  //1. Declaration of hooks
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const didMountRef = useRef(false);

  const isSmallScreen = useMediaQuery((theme) => theme?.breakpoints?.down("sm"));

  //2. Get the data from redux
  const {
    loginData,
    multiLanguageData,
    dashboardData,
    builderBucksCount,
    reportSuccess,
    jobSelectedLocation
  } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.DashBoard || {};
  const {
    TEXT_HI = English.DashBoard.TEXT_HI,
    TEXT_VIEW_PROFILE = English.DashBoard.TEXT_VIEW_PROFILE || "View Profile",
    TEXT_BUILDERBUCKS = English.DashBoard.TEXT_BUILDERBUCKS,
    BUTTON_EARN_BUILDERBUCKS = English.DashBoard.BUTTON_EARN_BUILDERBUCKS,
    TEXT_NEARBY_SITES = English.DashBoard.TEXT_NEARBY_SITES,
    TEXT_NO_SITES_AVAILABLE = English.DashBoard.TEXT_NO_SITES_AVAILABLE,
    TEXT_NO_LOCATION_PLACEHOLDER = English.DashBoard.TEXT_NO_LOCATION_PLACEHOLDER,
    TEXT_ENABLE_LOCATION = English.DashBoard.TEXT_ENABLE_LOCATION,
    TEXT_VIEW_SITES_ON_MAP = English.DashBoard.TEXT_VIEW_SITES_ON_MAP,
    TEXT_LOCATION_TEXT_1 = English.DashBoard.TEXT_LOCATION_TEXT_1,
    TEXT_LOCATION_TEXT_2 = English.DashBoard.TEXT_LOCATION_TEXT_2,
    TEXT_JOBS = English.DashBoard.TEXT_JOBS,
    TEXT_TIME = English.DashBoard.TEXT_TIME,
    TEXT_SEE_ALL = English.DashBoard.TEXT_SEE_ALL,
    TEXT_TIMESHEETS = English.DashBoard.TEXT_TIMESHEETS,
    TEXT_NO_TIMESHEET_PLACEHOLDER = English.DashBoard.TEXT_NO_TIMESHEET_PLACEHOLDER,
    TEXT_EXPENSES = English.DashBoard.TEXT_EXPENSES,
    TEXT_EXPENSES_PLACEHOLDER = English.DashBoard.TEXT_EXPENSES_PLACEHOLDER,
    TEXT_ANSWER_SUBMITTED = English.DashBoard.TEXT_ANSWER_SUBMITTED,
    TEXT_EARNED_BY_ANS = English.DashBoard.TEXT_EARNED_BY_ANS,
    BUTTON_LEARN_MORE = English.DashBoard.BUTTON_LEARN_MORE,
    TEXT_NEW_TIMESHEET = English.DashBoard.TEXT_NEW_TIMESHEET || "New Timesheet",
    TEXT_ADD_CLOCKIN = English.DashBoard.TEXT_ADD_CLOCKIN || "Clock In"
  } = LanguageData || {};

  const {
    TEXT_ADD_DESCRIPTION = English?.SiteDetail?.TEXT_ADD_DESCRIPTION,
    TEXT_REPORT = English?.SiteDetail?.TEXT_REPORT,
    TEXT_FLAG_ACTIVE = English?.SiteDetail?.TEXT_FLAG_ACTIVE,
    BUTTON_ADD_WEBSITE = English?.SiteDetail?.BUTTON_ADD_WEBSITE,
    TEXT_ADD_PICTURE = English?.SiteDetail?.TEXT_ADD_PICTURE
  } = multiLanguageData?.SiteDetail || {};

  const userId = loginData?.userInformation?.UserId;
  const accessToken = loginData?.accessToken;

  //3. Declaration of states - General
  const [surveyModal, setSurveyModal] = useState(false);
  const [currentUserLocation, setCurrentUserLocation] = useState({ lat: 0, lng: 0 });
  const [isLocationDefault, setIsLocationDefault] = useState(false);
  const [quizModal, setQuizModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openPostCommentModalWithSource, setOpenPostCommentModalWithSource] = useState(false);
  const [saveExpensesFlag, setSaveExpensesFlag] = useState(false);
  const [showAddExpensesModal, setShowAddExpensesModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [showEditExpensesModal, setShowEditExpensesModal] = useState(false);

  const [answerCount, setAnswercount] = useState(null);
  const [visibleQuestions, setVisibleQuestions] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [siteInfo, setSiteInfo] = useState([]);
  const [addSiteWebsiteModalOpen, setAddSiteWebsiteModalOpen] = useState(false);
  const [addDescriptionDialogOpen, setAddDescriptionDialogOpen] = useState(false);

  const [siteLoading, setSiteLoading] = useState([]);
  const [adsData, setAdsData] = useState([]);

  // Timesheet-specific states
  const [showTimesheetModal, setShowTimesheetModal] = useState(false);
  const [showClockInModal, setShowClockInModal] = useState(false);
  const [selectedTimesheet, setSelectedTimesheet] = useState(null);
  const [timesheetAction, setTimesheetAction] = useState("add");
  const [selectedJob, setSelectedJob] = useState([]);
  const [selectedClockInJob, setSelectedClockInJob] = useState([]);
  const [seletetdClockInTimesheet, setSeletetdClockInTimesheet] = useState(null);
  const [showJoblist, setShowJoblist] = useState(false);
  const [goallist, setGoallist] = useState([]);
  const [userGoalData, setUserGoalData] = useState([]);
  const [imageArray, setImageArray] = useState([]);
  const [pictureViewerOpen, setPictureViewer] = useState(false);
  const [imageIndex, setImageIndex] = useState(null);
  const [operation, setOperation] = useState("add");

  const [showSendTimesheet, setShowSendTimesheet] = useState(false);
  const [selectedTimesheetsToSend, setSelectedTimesheetsToSend] = useState([]);

  // Menu state for timesheet add options
  const [timesheetMenuAnchorEl, setTimesheetMenuAnchorEl] = useState(null);

  const [question, setQuestion] = useState("");
  const [chatbotLoader, setChatbotLoader] = useState(false);
  const [openChatbot, setOpenChatbot] = useState(false);
  const [chatbotResponse, setChatbotResponse] = useState([]); // keep full chat history
  const [chatbotSessionKey, setChatbotSessionKey] = useState(0);
  const currentChatHistoryIdRef = useRef(null);

  const open = Boolean(anchorEl);
  const timesheetMenuOpen = Boolean(timesheetMenuAnchorEl);
  const fileInputRef = useRef(null);

  const handleClickMoreMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const updateCurrentChatHistoryId = (historyId) => {
    const normalizedHistoryId = historyId ? Number(historyId) : null;
    currentChatHistoryIdRef.current = normalizedHistoryId;
  };

  const safeJsonParse = (value) => {
    if (typeof value !== "string") {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  };

  const parseHistoryAnswer = (rawAnswer) => {
    let answer = "";
    let sources = [];

    const assignFromObject = (data) => {
      if (!data || typeof data !== "object") {
        return;
      }

      answer = data?.Answer ?? data?.answer ?? data?.Description ?? data?.description ?? answer;

      const rawSources = data?.Sources ?? data?.sources ?? [];
      if (Array.isArray(rawSources)) {
        sources = rawSources;
      } else if (typeof rawSources === "string") {
        const parsedSources = safeJsonParse(rawSources);
        sources = Array.isArray(parsedSources) ? parsedSources : sources;
      }
    };

    if (typeof rawAnswer === "string") {
      const trimmedAnswer = rawAnswer.trim();
      if (!trimmedAnswer) {
        return { answer: "No answer available.", sources: [] };
      }

      const parsedAnswer = safeJsonParse(trimmedAnswer);
      if (Array.isArray(parsedAnswer) && parsedAnswer.length > 0) {
        assignFromObject(parsedAnswer[0]);
      } else if (parsedAnswer && typeof parsedAnswer === "object") {
        assignFromObject(parsedAnswer);
      } else {
        answer = trimmedAnswer;
      }
    } else if (Array.isArray(rawAnswer) && rawAnswer.length > 0) {
      assignFromObject(rawAnswer[0]);
    } else if (rawAnswer && typeof rawAnswer === "object") {
      assignFromObject(rawAnswer);
    }

    return {
      answer: answer || "No answer available.",
      sources: Array.isArray(sources) ? sources : []
    };
  };

  const normalizeChatbotHistoryRecord = (item, fallbackId) => {
    const parsedAnswer = parseHistoryAnswer(item?.answer ?? item?.source ?? item?.Answer ?? "");

    return {
      id: item?.id ?? item?.historyDetailId ?? fallbackId ?? Date.now(),
      question: item?.question ?? item?.description ?? "",
      answer: parsedAnswer.answer,
      sources: parsedAnswer.sources,
      isPending: false,
      historyDetailId: item?.historyDetailId ?? item?.id ?? fallbackId ?? 0
    };
  };

  const clearCurrentChatThread = () => {
    updateCurrentChatHistoryId(null);
    setChatbotLoader(false);
    setChatbotResponse([]);
  };

  const resetChatbotToNewChat = () => {
    setQuestion("");
    clearCurrentChatThread();
    setChatbotSessionKey((prev) => prev + 1);
    setOpenChatbot(true);
  };

  // Timesheet menu handlers
  const handleTimesheetMenuClick = (event) => {
    setTimesheetMenuAnchorEl(event.currentTarget);
  };

  const handleTimesheetMenuClose = () => {
    setTimesheetMenuAnchorEl(null);
  };

  const handleSendTimesheet = (timesheetDetail) => {
    // Handle sending a single timesheet or array of timesheets
    const timesheetsToSend = Array.isArray(timesheetDetail) ? timesheetDetail : [timesheetDetail];
    setSelectedTimesheetsToSend(timesheetsToSend);
    setShowSendTimesheet(true);
  };

  // 4. Declaration of useEffect
  useEffect(() => {
    const callInitialStage = async () => {
      setIsLoading(true);
      // callNotificationcount();
      await Promise.all([fetchDashboardData(), getDateDiffForSurvey(), fetchAdsData()]);
      setVisibleQuestions(true);
    };
    callInitialStage();
  }, []);

  // After add report to site refresh the site listing
  useEffect(() => {
    if (didMountRef.current) {
      if (reportSuccess !== true) {
        setIsLoading(true);
        fetchDashboardData();
      }
    } else {
      didMountRef.current = true;
    }
  }, [reportSuccess]);

  // ✅ Timesheet Functions
  const fetchGoalData = async () => {
    try {
      // Fetch user goals
      const goalsResponse = await Postrequestcall(
        FETCH_GOALS,
        {
          PageNr: 1,
          FullSearch: "",
          UserId: loginData?.userInformation?.UserId,
          IncludeRecordNr: true,
          SearchList: [{ createdBy: loginData?.userInformation?.UserId }]
        },
        loginData?.accessToken
      );

      if (goalsResponse?.data?.data) {
        const formattedGoals = goalsResponse.data.data.map((goal) => ({
          ...goal,
          key: goal.id,
          value: goal.name
        }));
        setUserGoalData(formattedGoals);
      }

      // Fetch goal details
      const goalDetailResponse = await Getrequestcall(
        `${GET_TIMESHEETGOAL_DETAIL}/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );

      if (goalDetailResponse.status === 200) {
        setGoallist(goalDetailResponse?.data?.data);
      }
    } catch (error) {
      console.error("fetchGoalData-> Error fetching goal data: ", error);
    }
  };

  const handleClick = async () => {
    setTimesheetAction("add");
    setSelectedTimesheet(null);
    setSelectedJob([]);
    setOperation("add");

    // Fetch goal data when opening timesheet modal
    await fetchGoalData();

    setShowTimesheetModal(true);
    handleTimesheetMenuClose();
  };

  const handleClockInClick = async () => {
    setOperation("add");
    setSeletetdClockInTimesheet(null);
    setSelectedClockInJob([]);

    // Fetch goal data when opening clock-in modal
    await fetchGoalData();

    setShowClockInModal(true);
    handleTimesheetMenuClose();
  };

  const onTimesheetViewclick = (e, item) => {
    setTimesheetAction("view");
    setSelectedTimesheet(item);
    setShowTimesheetModal(true);
  };

  const handleTimesheetSaveComplete = async () => {
    // Refresh dashboard data after timesheet operations

    await fetchDashboardData();
    setShowTimesheetModal(false);
    setShowClockInModal(false);
    setSelectedJob([]);
    setSelectedClockInJob([]);
    setSelectedTimesheet(null);
    setSeletetdClockInTimesheet(null);
    setTimesheetAction("add");
    setOperation("add");
  };

  // Other existing functions...
  const fetchDashboardData = async () => {
    const currentLocation = await Getcurrentlocation(multiLanguageData);

    // Set isLocationDefault state
    const isDefault = currentLocation?.default === true;
    setIsLocationDefault(isDefault);

    // Update currentUserLocation state - use (0,0) if default to match API logic
    if (isDefault) {
      setCurrentUserLocation({ lat: 0, lng: 0 });
    } else {
      setCurrentUserLocation({ lat: currentLocation?.lat || 0, lng: currentLocation?.lng || 0 });
    }

    try {
      let postObj = {};
      if (isDefault) {
        postObj = {
          UserId: userId,
          UserLatitude: 0,
          UserLongitude: 0,
          JobLatitude: jobSelectedLocation?.lat || 0,
          JobLongitude: jobSelectedLocation?.lng || 0,
          RadiusKm: jobSelectedLocation?.range || 80
        };
      } else {
        postObj = {
          UserId: userId,
          UserLatitude: currentLocation?.lat || 0,
          UserLongitude: currentLocation?.lng || 0,
          JobLatitude: jobSelectedLocation?.lat || currentLocation?.lat || 0,
          JobLongitude: jobSelectedLocation?.lng || currentLocation?.lng || 0,
          RadiusKm: jobSelectedLocation?.range || 80
        };
      }
      const response = await Postrequestcall(FETCH_DASHBOARD_DATA, postObj, accessToken);
      dispatch(setMainNotification(response?.data?.data?.[0]?.notificationCount));
      // Use chat count from dashboard data as requested
      // dispatch(setChatCount(response?.data?.data?.[0]?.notificationCount ?? 0));
      dispatch(setDashboardData(response?.data?.data?.[0]));
      dispatch(setBuilderBucksCount(response?.data?.data[0]?.builderBucksCount ?? 0));
    } catch (error) {
      console.error("fetchDashboardData-> Error Fetching Dashboard Data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAdsData = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: userId,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        SearchList: [
          {
            Active: true
          }
        ],
        SortList: [
          {
            FieldName: "orderNo",
            Direction: "ASC"
          }
        ]
      };
      let adsRes = await Postrequestcall(FETCH_ADS, obj, loginData?.accessToken);
      setAdsData(adsRes?.data?.data || []);
    } catch (error) {
      console.log("FetchAdsData-> Error When Getting Ads Data: ", error);
    }
  };

  // 5. API calling Function

  const getDateDiffForSurvey = async () => {
    try {
      const response = await Getrequestcall(`${GET_SURVEY_DATE}/${userId}`, loginData?.accessToken);
      const a = moment(new Date());
      const b = moment(response?.data?.data?.[0].joinedBuildIdDate);
      const diffInDays = a.diff(b, "days");
      if (!response?.status) {
        setSurveyModal(false);
        return;
      }

      if (diffInDays == 30 && response?.data?.data?.[0]?.surveyDate == "1900-01-01T00:00:00") {
        setSurveyModal(true);
      } else {
        if (
          moment(new Date()).format("YYYY-MM-DD") ==
            moment(response?.data?.data?.[0]?.surveyDate).format("YYYY-MM-DD") &&
          dispatch(setSurveyLaterToday(false))
        ) {
          setSurveyModal(true);
        } else {
          if (
            moment(response?.data?.data?.[0]?.surveyDate).format("YYYY-MM-DD") != "1900-01-01" &&
            moment(response?.data?.data?.[0]?.surveyDate).format("YYYY-MM-DD") <
              moment(new Date()).format("YYYY-MM-DD")
          ) {
            setSurveyModal(true);
          } else {
            setSurveyModal(false);
          }
        }
      }
    } catch (error) {
      console.log(
        "getDateDiffForSurvey-> Error Getting Dashboard Notification Count(For Survey Date): " +
          error
      );
    }
  };

  // 6. Other event handlers
  const handleInfoToggler = () => {
    setOpenPostCommentModalWithSource(true);
  };

  const handleSiteInfo = (item) => {
    dispatch(setSelectedSiteId(item?.id));
    dispatch(setSelectedcompany()); // store the company details in redux
    let mapModal = {
      open: true,
      from: "dashboard",
      select: "site"
    };
    dispatch(setShowmapmodal(mapModal));
  };

  const convertToHoursAndMinutes = (decimalHours) => {
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);
    return { hours, minutes };
  };

  const learnMore = () => {
    navigate("/reward-store");
  };

  const goToTimesheet = () => {
    navigate("/timesheets");
  };

  const goToSites = () => {
    navigate("/sites");
  };

  const goToExpenses = () => {
    navigate("/expenses");
  };

  const goToProfile = () => {
    navigate(`/${userId}`);
  };

  const goToRewardActivity = () => {
    navigate("/reward-store/earn-builderbucks/earn-rewards");
  };

  const renderCityText = (city, country) => {
    let address = "";
    if (city && country) {
      address = city + ", " + country;
    } else if (city) {
      address = city;
    } else if (country) {
      address = country;
    }
    return address?.trim();
  };

  const LocationAlert = () => {
    const alertObj = {
      showAlert: true,
      text: TEXT_LOCATION_TEXT_1,
      text2: TEXT_LOCATION_TEXT_2
    };
    dispatch(setShowalert(alertObj));
  };

  const setSiteActiveStatus = async (mainId) => {
    try {
      let payload = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: mainId
          }
        ]
      };
      let getResponse = await Postrequestcall(SITE_ACTIVE, payload, loginData?.accessToken);
      if (getResponse.status === 201) {
        let id = siteLoading;
        id.pop(mainId || 0);
        let clone = dashboardData?.sites;

        const updatedData = clone?.map((site) => {
          if (site?.id === mainId) {
            return {
              ...site,
              active: true
            };
          } else {
            return site;
          }
        });
        dispatch(
          setDashboardData({
            ...dashboardData,
            sites: updatedData
          })
        );
        setSiteLoading(id);
      }
      setAnchorEl(false);
    } catch (error) {
      let id = siteLoading;
      id.pop(mainId || 0);
      setSiteLoading(id);
      console.log("setSiteActiveStatus-> Error When Making Site Active: ", error);
    }
  };

  const openSiteReport = () => {
    let reportObj = {
      showReport: true,
      name: Pages?.site?.name,
      AppScreenId: Pages?.site?.id,
      recordId: siteInfo?.id ?? 0
    };
    dispatch(setShowReport(reportObj));
    setAnchorEl(false);
  };

  const handleSiteImageSelect = async (event) => {
    try {
      const files = Array.from(event.target.files);
      if (!files.length) {
        return;
      }
      const userId = Number(loginData?.userInformation?.UserId);
      const siteId = siteInfo?.id ?? 0;
      const obj = {
        UserId: userId,
        ReturnRecordId: true,
        ReturnRecordError: false,
        SaveList: [
          {
            Id: 0,
            FormatTypeId: 1,
            PostedByUserId: userId,
            AppId: 2,
            AppRecordId: siteId,
            Message: "<<<picture>>>",
            ModifiedBy: userId
          }
        ]
      };
      const postRes = await Postrequestcall(SAVE_POSTS, obj, loginData?.accessToken);
      const postId = postRes?.data?.data?.[0]?.objData?.id;
      let inappropriateFound = false;
      if (!postId) throw new Error("Post ID not returned from SAVE_POSTS");

      const results = await Promise.allSettled(
        files.map((file) => {
          const formData = new FormData();
          formData.append("Id", 0);
          formData.append("PostId", postId);
          formData.append("ModifiedBy", userId);
          formData.append("Pictures", file);
          return Fileuploadrequestcall(SAVE_POST_PICTURE, formData, loginData?.accessToken);
        })
      );

      results.forEach((result) => {
        if (result.status === false) {
          inappropriateFound = true;
        } else if (result.value.data.message === "Content Inappropriate") {
          inappropriateFound = true;
        }
      });

      if (inappropriateFound) {
        alert(
          "One or more images have been restricted from being uploaded due to inappropriate content."
        );
      }
    } catch (error) {
      console.error("handleSiteImageSelect-> Error When Saving Site Picture: ", error);
    }
  };

  // Card rendering functions...
  const userInfoCard = () => {
    return (
      <Card className="pagelist-content" sx={{ height: "130px", backgroundColor: BIBlue }}>
        <Stack p={1.5} pl={2} pr={2} spacing={2}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            onClick={goToProfile}
            sx={{ cursor: "pointer" }}>
            <Stack>
              <Typography color="white" variant="h5" fontWeight={"bold"}>
                {TEXT_HI} {loginData?.userInformation?.FirstName}
              </Typography>
              <Typography
                variant="subtitle2"
                color="white"
                noWrap
                sx={{ fontSize: "12px", marginTop: "10px" }}>
                {TEXT_VIEW_PROFILE}{" "}
                <KeyboardArrowRightIcon
                  fontSize="16px"
                  sx={{ fontWeight: "bolder", position: "relative", top: "2px" }}
                />
              </Typography>
            </Stack>
            <Avatar
              sx={{ width: 56, height: 56 }}
              alt="contact-PictureUrl"
              src={dashboardData?.userPicture}
            />
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Stack alignItems={"flex-end"} spacing={1} direction={"row"}>
              <Typography color="white" variant="h4">
                {builderBucksCount}
              </Typography>
              <Typography color="white" variant="h6">
                {TEXT_BUILDERBUCKS}
              </Typography>
            </Stack>
            <Button
              variant="contained"
              sx={{ backgroundColor: "white", color: BIBlue, borderRadius: "7px" }}
              onClick={goToRewardActivity}>
              {BUTTON_EARN_BUILDERBUCKS}
            </Button>
          </Stack>
        </Stack>
      </Card>
    );
  };

  const buildIdInfoCard = () => {
    const hasCustomColor = dashboardData?.announcement?.color;
    const backgroundColor = hasCustomColor || BILightYellow;
    const textColor = hasCustomColor ? "white" : "inherit";
    
    return (
      <Card
        className="pagelist-content"
        sx={{ height: "130px", backgroundColor, cursor: "pointer" }}>
        <Stack spacing={1} direction={"row"} p={2} onClick={handleInfoToggler}>
          <CampaignIcon sx={{ color: textColor }} />
          <Typography color={textColor}>{dashboardData?.announcement?.message}</Typography>
        </Stack>
      </Card>
    );
  };

  const progressCard = () => {
    return (
      <Card className="pagelist-content">
        <ProgressBar from={"new-dashboard"} dashboardData={dashboardData} />
      </Card>
    );
  };

  const siteCard = () => {
    return (
      <Card
        className="pagelist-content"
        sx={{
          height: dashboardData?.sites?.length !== 0 ? (isSmallScreen ? "330px" : "400px") : "200px"
        }}>
        <Stack p={2} spacing={1.5}>
          <Typography sx={{ cursor: "pointer" }} variant="h5" onClick={goToSites}>
            {TEXT_NEARBY_SITES}
          </Typography>
          {dashboardData?.sites !== null && dashboardData?.sites?.length !== 0 ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  overflowX: "auto",
                  scrollbarWidth: "none",
                  gap: 1.5
                }}>
                {dashboardData?.sites?.map((item, index) => (
                  <>
                    {!siteLoading.includes(item?.id) ? (
                      <Card
                        className="pagelist-content"
                        key={index}
                        sx={{
                          width: isSmallScreen ? 200 : 350,
                          flex: "0 0 auto"
                        }}
                        onClick={() => handleSiteInfo(item)}>
                        <Box
                          sx={{
                            position: "relative",
                            width: "100%",
                            height: isSmallScreen ? 160 : 195
                          }}>
                          <Box
                            component="img"
                            src={item?.sitePicture === "" ? placeholder_img : item?.sitePicture}
                            onError={(event) => (event.target.src = placeholder_img)}
                            alt="No Image"
                            loading="lazy"
                            sx={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              cursor: "pointer"
                            }}
                          />
                        </Box>
                        <Box
                          p={2}
                          display={"flex"}
                          flexDirection={"row"}
                          justifyContent={"space-between"}
                          alignItems={"center"}>
                          <Stack>
                            <Typography variant="body1">{item?.name || "Unnamed Site"}</Typography>
                            <Typography variant="body2" color="textSecondary">
                              {item?.address}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                              {renderCityText(item?.city, item?.country)}
                            </Typography>
                          </Stack>
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              setSiteInfo(item);
                              handleClickMoreMenu(e);
                            }}>
                            <MoreIcon />
                          </IconButton>
                        </Box>
                      </Card>
                    ) : (
                      <Card
                        className="pagelist-content"
                        key={siteInfo?.id}
                        sx={{
                          width: isSmallScreen ? 200 : 300,
                          flex: "0 0 auto"
                        }}>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={isSmallScreen ? 160 : 195}
                          sx={{ bgcolor: "grey.500" }}
                        />
                        <Box p={2}>
                          <Skeleton
                            variant="text"
                            width="80%"
                            height={24}
                            sx={{ bgcolor: "grey.500" }}
                          />
                          <Skeleton
                            variant="text"
                            width="60%"
                            height={20}
                            sx={{ bgcolor: "grey.500" }}
                          />
                          <Skeleton
                            variant="text"
                            width="40%"
                            height={20}
                            sx={{ bgcolor: "grey.500" }}
                          />
                        </Box>
                      </Card>
                    )}
                  </>
                ))}
                <Menu
                  id="demo-positioned-menu"
                  aria-labelledby="demo-positioned-button"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}>
                  {siteInfo?.active ? null : (
                    <MenuItem
                      onClick={() => {
                        let id = [...siteLoading];
                        id.push(siteInfo?.id || 0);
                        setSiteLoading(id);
                        setSiteActiveStatus(siteInfo?.id);
                        setAnchorEl(false);
                      }}
                      style={{ color: BIBlue }}
                      dense>
                      {TEXT_FLAG_ACTIVE}
                    </MenuItem>
                  )}

                  {(siteInfo?.address !== "" ||
                    siteInfo?.latitude !== 0 ||
                    siteInfo?.longitude !== 0) && (
                    <MenuItem
                      style={{ color: BIBlue }}
                      dense
                      onClick={() => {
                        fileInputRef.current.click();
                        setAnchorEl(false);
                      }}>
                      {TEXT_ADD_PICTURE}
                    </MenuItem>
                  )}

                  <MenuItem
                    style={{ color: BIBlue }}
                    dense
                    onClick={() => {
                      setAddDescriptionDialogOpen(true);
                      setAnchorEl(false);
                    }}>
                    {TEXT_ADD_DESCRIPTION}
                  </MenuItem>
                  {(siteInfo?.website === "" || siteInfo?.website === null) && (
                    <MenuItem
                      style={{ color: BIBlue }}
                      dense
                      onClick={() => {
                        setAddSiteWebsiteModalOpen(true);
                        setAnchorEl(false);
                      }}>
                      {BUTTON_ADD_WEBSITE}
                    </MenuItem>
                  )}

                  <MenuItem
                    style={{ color: BIRed }}
                    dense
                    onClick={() => {
                      openSiteReport();
                    }}>
                    {TEXT_REPORT}
                  </MenuItem>
                </Menu>

                <input
                  type="file"
                  accept="image/*"
                  multiple
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleSiteImageSelect}
                />
              </Box>
            </>
          ) : dashboardData?.sites == null ? (
            <Box
              gap={1}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}>
              <Typography variant="body1" color="textSecondary">
                {TEXT_NO_SITES_AVAILABLE}
              </Typography>
            </Box>
          ) : (
            <Box
              gap={1}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}>
              <Typography variant="body1" color="textSecondary">
                {TEXT_NO_LOCATION_PLACEHOLDER}
              </Typography>
              <Button variant="text" onClick={LocationAlert}>
                {TEXT_ENABLE_LOCATION}
              </Button>
            </Box>
          )}
          <Box display={"flex"} justifyContent={"center"}>
            <Button
              color="primary"
              variant="outlined"
              sx={{ textTransform: "none" }}
              onClick={goToSites}>
              {TEXT_VIEW_SITES_ON_MAP}
            </Button>
          </Box>
        </Stack>
      </Card>
    );
  };

  const jobCard = () => {
    return (
      <Card className="pagelist-content" style={{ overflow: "scroll" }}>
        <Stack p={2} spacing={2}>
          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
            <Typography variant="h5">{"Nearby Jobs"}</Typography>
          </Stack>
          {dashboardData?.jobPosts?.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                overflowX: "scroll",
                scrollbarWidth: "none",
                gap: 2
              }}>
              {dashboardData?.jobPosts?.map((job) => (
                <Card
                  key={job.id}
                  className="pagelist-content"
                  onClick={() => navigate("/job-postings", { state: { jobId: job.id } })}
                  sx={{
                    width: "350px",
                    minHeight: "300px",
                    height: "auto",
                    flex: "0 0 auto",
                    cursor: "pointer",
                    overflowX: "scroll"
                  }}>
                  <Stack spacing={1.5} p={2}>
                    {/* Job Title */}
                    <Typography variant="h6" fontWeight={600}>
                      {job.title}
                    </Typography>

                    {!job?.jobPostTypes?.length && !job?.trades?.length && (
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ fontStyle: "italic" }}>
                        No job type/trade provided
                      </Typography>
                    )}
                    {/* Chips Section */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        flexWrap: "wrap",
                        maxHeight: "60px",
                        overflow: "hidden"
                      }}>
                      {[...(job?.jobPostTypes || []), ...(job?.trades || [])]
                        .slice(0, 3)
                        .map((tag, index) => (
                          <Chip
                            key={index}
                            label={tag?.typeName || tag?.tradeName}
                            size="small"
                            sx={{
                              borderRadius: "12px",
                              fontSize: "12px",
                              fontWeight: 500,
                              height: "20px"
                            }}
                          />
                        ))}
                      {[...(job?.jobPostTypes || []), ...(job?.trades || [])].length > 3 && (
                        <Chip
                          label={`+${[...(job?.jobPostTypes || []), ...(job?.trades || [])].length - 3} more`}
                          size="small"
                          sx={{
                            borderRadius: "12px",
                            fontSize: "12px",
                            fontWeight: 500,
                            height: "20px",
                            backgroundColor: "#e0e0e0"
                          }}
                        />
                      )}
                    </Box>

                    {/* Site Section */}
                    <Box>
                      <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        mb={0.5}
                        noWrap
                        title={job?.site?.name}>
                        {job?.site?.name || "Site"}
                      </Typography>
                      <Box
                        sx={{
                          width: "100%",
                          height: "140px",
                          borderRadius: "8px",
                          overflow: "hidden",
                          backgroundColor: "#f5f5f5",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}>
                        {job?.site && (job.site?.latitude || job.site?.longitude) ? (
                          <GoogleMap
                            options={{
                              disableDefaultUI: true,
                              draggable: false,
                              scrollwheel: false,
                              disableDoubleClickZoom: true,
                              keyboardShortcuts: false,
                              styles: [
                                {
                                  featureType: "poi",
                                  elementType: "all",
                                  stylers: [{ visibility: "off" }]
                                },
                                {
                                  featureType: "transit",
                                  elementType: "all",
                                  stylers: [{ visibility: "off" }]
                                }
                              ]
                            }}
                            center={{
                              lat: job?.site?.latitude || 0,
                              lng: job?.site?.longitude || 0
                            }}
                            zoom={14}
                            mapContainerStyle={{
                              width: "100%",
                              height: "100%"
                            }}>
                            <Marker
                              position={{
                                lat: job?.site?.latitude || 0,
                                lng: job?.site?.longitude || 0
                              }}
                              icon={{
                                url: mapMarkerYellow,
                                scaledSize: new window.google.maps.Size(30, 40)
                              }}
                            />
                          </GoogleMap>
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            No Site
                          </Typography>
                        )}
                      </Box>
                    </Box>

                    {/* Company Section */}
                    <Box>
                      <Typography variant="subtitle2" fontWeight={600}>
                        Company
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        noWrap
                        title={job?.companyName}>
                        {job?.companyName || "No Company Name"}
                      </Typography>
                    </Box>
                  </Stack>
                </Card>
              ))}
            </Box>
          ) : isLocationDefault ||
            (currentUserLocation.lat === 0 && currentUserLocation.lng === 0) ? (
            <Box
              gap={1}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              py={4}>
              <Typography variant="body1" color="textSecondary">
                {TEXT_NO_LOCATION_PLACEHOLDER}
              </Typography>
              <Button variant="text" onClick={LocationAlert}>
                {TEXT_ENABLE_LOCATION}
              </Button>
            </Box>
          ) : (
            <Box
              gap={1}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              py={4}>
              <Typography variant="body1" color="textSecondary">
                No jobs available
              </Typography>
            </Box>
          )}
          <Box display={"flex"} justifyContent={"center"}>
            <Button
              color="primary"
              variant="outlined"
              sx={{ textTransform: "none" }}
              onClick={() => navigate("/job-postings")}>
              Search job postings
            </Button>
          </Box>
        </Stack>
      </Card>
    );
  };

  const answerCard = () => {
    return (
      <>
        <Card className="pagelist-content" sx={{ backgroundColor: BILightGrey, width: "100%" }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between"
              }}>
              <Typography variant="body2" ml={1} color="textSecondary">
                {TEXT_ANSWER_SUBMITTED}
              </Typography>
              <IconButton
                size="small"
                color="default"
                onClick={() => {
                  setVisibleQuestions(false);
                  setAnswercount(null);
                }}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}>
              <EmojiEventsIcon sx={{ height: "208px", width: "208px", color: "#ffbc0a" }} />
              <Typography variant="h3" color="primary">
                {answerCount} {TEXT_BUILDERBUCKS}
              </Typography>

              <Typography variant="body2" mt={1} color="textSecondary">
                {TEXT_EARNED_BY_ANS}
                <Button variant="text" size="small" onClick={learnMore}>
                  {BUTTON_LEARN_MORE}
                </Button>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </>
    );
  };

  const timesheetCard = () => {
    return (
      <Card
        className="pagelist-content"
        sx={{ height: "350px", display: "flex", flexDirection: "column" }}>
        <Stack p={2} spacing={1} sx={{ flexGrow: 1, flexBasis: 0 }}>
          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
            <Typography sx={{ cursor: "pointer" }} variant="h5" onClick={goToTimesheet}>
              {TEXT_TIMESHEETS}
            </Typography>
            <IconButton onClick={handleTimesheetMenuClick}>
              <AddIcon />
            </IconButton>
          </Stack>
          <Box sx={{ flexGrow: 1, minHeight: 0, overflow: "auto" }}>
            {dashboardData?.timeSheets !== null && dashboardData?.timeSheets?.length > 0 ? (
              <List disablePadding>
                <Stack spacing={1}>
                  {dashboardData?.timeSheets?.map((item, index) => {
                    const { hours, minutes } = convertToHoursAndMinutes(item?.totalHours || 0);
                    return (
                      <Card key={index.toString()} className="pagelist-content">
                        <ListItem sx={{ m: 0 }} key={index.toString()} disablePadding>
                          <ListItemButton onClick={(e) => onTimesheetViewclick(e, item)}>
                            <ListItemText
                              primary={
                                <Stack
                                  justifyContent={"space-between"}
                                  direction={"row"}
                                  alignItems={"center"}>
                                  <Typography variant="body1">
                                    {moment(item?.timesheetDate).format("MMMM DD, YYYY")}
                                  </Typography>
                                  <Stack direction={"row"} spacing={2}>
                                    <Stack alignItems={"center"}>
                                      <Typography variant="body1" color="textSecondary">
                                        {TEXT_JOBS}
                                      </Typography>
                                      <Typography variant="body1">{item?.noOfJobs}</Typography>
                                    </Stack>
                                    <Stack alignItems={"center"}>
                                      <Typography variant="body1" color="textSecondary">
                                        {TEXT_TIME}
                                      </Typography>
                                      <Typography variant="body1">{`${hours}h ${minutes}m`}</Typography>
                                    </Stack>
                                  </Stack>
                                </Stack>
                              }
                            />
                          </ListItemButton>
                        </ListItem>
                      </Card>
                    );
                  })}
                </Stack>
              </List>
            ) : (
              <Box height={"100%"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                <Typography variant="body1" color="textSecondary">
                  {TEXT_NO_TIMESHEET_PLACEHOLDER}
                </Typography>
              </Box>
            )}
          </Box>
          {dashboardData?.timeSheets?.length > 0 && (
            <Box display={"flex"} justifyContent={"center"} mt={2}>
              <Button
                color="inherit"
                variant="contained"
                sx={{ textTransform: "none", borderRadius: "15px", boxShadow: "none" }}
                onClick={goToTimesheet}>
                {TEXT_SEE_ALL}
              </Button>
            </Box>
          )}
        </Stack>
      </Card>
    );
  };

  const expensesCard = () => {
    return (
      <Card
        className="pagelist-content"
        sx={{ height: "350px", display: "flex", flexDirection: "column" }}>
        <Stack p={2} spacing={1} sx={{ flexGrow: 1, flexBasis: 0 }}>
          <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
            <Typography sx={{ cursor: "pointer" }} variant="h5" onClick={goToExpenses}>
              {TEXT_EXPENSES}
            </Typography>
            <IconButton
              onClick={() => {
                setShowAddExpensesModal(true);
              }}>
              <AddIcon />
            </IconButton>
          </Stack>
          <Box sx={{ flexGrow: 1, minHeight: 0, overflow: "auto" }}>
            {dashboardData?.expenses !== null ? (
              <List disablePadding>
                <Stack spacing={1}>
                  {dashboardData?.expenses?.map((item, index) => (
                    <Card key={index.toString()} className="pagelist-content">
                      <ListItem
                        sx={{ m: 0 }}
                        key={index.toString()}
                        disablePadding
                        secondaryAction={
                          <Typography variant="h6" color="textPrimary">
                            $ {item.totalAmount ? item.totalAmount.toFixed(2) : ""}
                          </Typography>
                        }>
                        <ListItemButton
                          onClick={() => {
                            setSelectedExpense(item);
                            setShowEditExpensesModal(true);
                          }}>
                          <ListItemText
                            primary={item.description}
                            secondary={moment(item.expenseDate).format("MMMM DD, YYYY")}
                          />
                        </ListItemButton>
                      </ListItem>
                    </Card>
                  ))}
                </Stack>
              </List>
            ) : (
              <Box
                height={"100%"}
                p={4}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                textAlign={"center"}>
                <Typography variant="body1" color="textSecondary">
                  {TEXT_EXPENSES_PLACEHOLDER}
                </Typography>
              </Box>
            )}
          </Box>
          {dashboardData?.expenses?.length > 0 && (
            <Box display={"flex"} justifyContent={"center"} mt={2}>
              <Button
                color="inherit"
                variant="contained"
                sx={{ textTransform: "none", borderRadius: "15px", boxShadow: "none" }}
                onClick={goToExpenses}>
                {TEXT_SEE_ALL}
              </Button>
            </Box>
          )}
        </Stack>
      </Card>
    );
  };

  // After add reward refresh the reward count
  const refreshBuilderBucks = async () => {
    try {
      const userRewardUrl = `${USER_REWARD_AMOUNT}/${userId}`;
      let getResponse = await Getrequestcall(userRewardUrl, accessToken);
      if (getResponse?.data?.data) {
        dispatch(setBuilderBucksCount(getResponse?.data?.data?.bucks ?? 0));
      }
    } catch (error) {
      console.log("getBuilderBucksCountAction-> Error When Getting Builder Bucks Count: ", error);
      dispatch(setBuilderBucksCount(0));
    }
  };

  const callAsk = async (currentQuestion) => {
    const trimmedQuestion = currentQuestion?.trim();
    if (!trimmedQuestion) {
      return;
    }
    const requestId = Date.now();
    try {
      setChatbotLoader(true);
      setOpenChatbot(true);
      setQuestion("");
      setChatbotResponse((prev) => {
        const previousHistory = Array.isArray(prev) ? prev : prev ? [prev] : [];
        return [
          ...previousHistory,
          {
            id: requestId,
            question: trimmedQuestion,
            answer: "",
            sources: [],
            isPending: true
          }
        ];
      });
      let historyId = currentChatHistoryIdRef.current ?? 0;
      const userId = loginData?.userInformation?.UserId ?? 0;
      const token = loginData?.accessToken ?? "";

      if (!historyId && userId && token) {
        try {
          const savePayload = {
            UserId: userId,
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: [
              {
                Id: 0,
                UserId: userId,
                Description: trimmedQuestion,
                ModifiedBy: userId
              }
            ]
          };
          const saveRes = await Postrequestcall(
            RAG_SAVE_CHATBOT_HISTORY_ID_DETAILS,
            savePayload,
            token
          );
          const getId =
            saveRes?.data?.data?.[0]?.objData?.id ??
            saveRes?.data?.data?.[0]?.id ??
            saveRes?.data?.objData?.id ??
            saveRes?.data?.id ??
            0;
          historyId = Number(getId) || 0;
          if (historyId) {
            updateCurrentChatHistoryId(historyId);
          }
        } catch (e) {
          historyId = 0;
        }
      }

      let payload = {
        question: trimmedQuestion,
        filters: {},
        userId,
        HistoryDetailId: historyId
      };
      let response = await Postrequestcall(RAG_ASK, payload, token);
      const responseData = response?.data?.data ?? response?.data ?? response ?? {};
      setChatbotResponse((prev) => {
        const previousHistory = Array.isArray(prev) ? prev : prev ? [prev] : [];
        return previousHistory.map((item) =>
          item?.id === requestId
            ? {
                ...item,
                answer: responseData?.answer || "No answer available.",
                sources: Array.isArray(responseData?.sources) ? responseData.sources : [],
                isPending: false
              }
            : item
        );
      });
    } catch (error) {
      console.log("Error occurred while calling RAG_ASK: ", error);
      setChatbotResponse((prev) => {
        const previousHistory = Array.isArray(prev) ? prev : prev ? [prev] : [];
        return previousHistory.map((item) =>
          item?.id === requestId
            ? {
                ...item,
                answer: "Something went wrong. Please try again.",
                sources: [],
                isPending: false
              }
            : item
        );
      });
    } finally {
      setChatbotLoader(false);
    }
  };

  const onQuetionchange = (e) => {
    setQuestion(e.target.value);
  };

  // 7. Return UI
  return (
    <>
      <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3 }}>
        <Box className="chat-bot">
          <Box
            className="chat-icon"
            onClick={() => {
              resetChatbotToNewChat();
            }}
            sx={{ cursor: "pointer" }}>
            <SmartToyIcon className="chat-icon-svg" />
          </Box>
          <Box className="chat-input-wrapper">
            <TextField
              fullWidth
              placeholder="Ask me about BuildID..."
              value={question}
              onChange={onQuetionchange}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  callAsk(question);
                }
              }}
              variant="outlined"
              className="chat-input"
              size="small"
            />
            <IconButton
              className="send-btn"
              onClick={() => {
                callAsk(question);
              }}>
              <SendIcon />
            </IconButton>
          </Box>
        </Box>
        <Card className="main-content-card" sx={{ mt: 0 }} style={{ marginTop: "15px" }}>
          <Box className="main-content-card-list">
            <Grid container spacing={1.5}>
              {isLoading ? (
                <>
                  <Grid size={{ xs: 12, md: 6 }}> {userInfoCardSkeleton()} </Grid>
                  <Grid size={{ xs: 12, md: 6 }}> {buildIdInfoCardSkeleton()} </Grid>
                  <Grid size={{ xs: 12, md: 12 }}>{questionsSkeleton()}</Grid>
                  <Grid size={{ xs: 12, md: 12 }}>{<AdsCarouselSkeleton />}</Grid>
                  <Grid size={{ xs: 12, md: 12 }}> {<SiteCardSkeleton />} </Grid>
                  <Grid size={{ xs: 12, md: 6 }}> {timesheetCardSkeleton()} </Grid>
                  <Grid size={{ xs: 12, md: 6 }}> {expensesCardSkeleton()} </Grid>
                </>
              ) : (
                <>
                  <Grid size={{ xs: 12, md: 6 }}> {userInfoCard()} </Grid>
                  <Grid size={{ xs: 12, md: 6 }}> {buildIdInfoCard()} </Grid>
                  {dashboardData?.isProgressBarDismiss == false && (
                    <Grid size={{ xs: 12, md: 12 }}> {progressCard()} </Grid>
                  )}
                  {visibleQuestions && answerCount === null ? (
                    <Grid size={{ xs: 12, md: 12 }}>
                      <Questions
                        from={"new-dashboard"}
                        setVisibleQuestions={async () => {
                          await refreshBuilderBucks();
                          setVisibleQuestions(false);
                        }}
                        setAnswercount={setAnswercount}
                      />
                    </Grid>
                  ) : (
                    answerCount !== null && <Grid size={{ xs: 12, md: 12 }}>{answerCard()}</Grid>
                  )}
                  {adsData.length > 0 && (
                    <Grid size={{ xs: 12, md: 12 }}> {<AdsCarousel adsData={adsData} />} </Grid>
                  )}
                  <Grid size={{ xs: 12, md: 12 }}> {siteCard()} </Grid>
                  <Grid size={{ xs: 12, md: 12 }}> {jobCard()} </Grid>
                  <Grid size={{ xs: 12, md: 12 }}>
                    {" "}
                    <AdContainer />{" "}
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}> {timesheetCard()} </Grid>
                  <Grid size={{ xs: 12, md: 6 }}> {expensesCard()} </Grid>
                </>
              )}
            </Grid>
          </Box>
        </Card>

        {/* Existing Modals */}
        {openPostCommentModalWithSource && (
          <PostComment
            open={openPostCommentModalWithSource}
            onClose={() => setOpenPostCommentModalWithSource(false)}
            from="new-dashboard"
            postItem={dashboardData?.announcement}
          />
        )}

        {showAddExpensesModal && (
          <Addexpenses
            isOpen={showAddExpensesModal}
            fetchExpenses={fetchDashboardData}
            editListItemDetails={selectedExpense}
            onClose={() => {
              setSelectedExpense(null);
              setShowAddExpensesModal(false);
            }}
            setSaveExpensesFlag={setSaveExpensesFlag}
            setShowEditExpensesModal={setShowEditExpensesModal}
          />
        )}

        {showEditExpensesModal && (
          <ViewExpenses
            openModal={showEditExpensesModal}
            closeModal={() => {
              setShowEditExpensesModal(false);
              setSaveExpensesFlag(false);
              setSelectedExpense(null);
            }}
            expensesDataId={selectedExpense}
            setShowAddExpensesModal={setShowAddExpensesModal}
            setSelectedExpense={setSelectedExpense}
            saveExpensesFlag={saveExpensesFlag}
            fetchExpensesData={fetchDashboardData}
            activeTab={"SENT"}
          />
        )}

        {surveyModal && (
          <SurveyModal
            open={surveyModal}
            onClose={() => {
              setSurveyModal(false);
            }}
            setQuizModal={setQuizModal}
          />
        )}
        {quizModal && (
          <SurveyQuizModal
            setSurveyModal={setSurveyModal}
            open={quizModal}
            onClose={() => {
              setQuizModal(false);
            }}
          />
        )}
        {addSiteWebsiteModalOpen && (
          <AddWebsiteModal
            open={addSiteWebsiteModalOpen}
            onClose={() => {
              setAddSiteWebsiteModalOpen(false);
            }}
            from="SiteCard"
            data={siteInfo || {}}
            onSaveClick={() => {
              let id = [...siteLoading];
              id.push(siteInfo?.id || 0);
              setSiteLoading(id);
            }}
            onDataSave={() => {
              let clone = dashboardData?.sites;

              const updatedData = clone?.map((site) => {
                if (site?.id === siteInfo?.id) {
                  return {
                    ...site,
                    website: " "
                  };
                } else {
                  return site;
                }
              });
              dispatch(
                setDashboardData({
                  ...dashboardData,
                  sites: updatedData
                })
              );
              let id = siteLoading;
              id.pop(siteInfo?.id || 0);
              setSiteLoading(id);
            }}
          />
        )}
        {addDescriptionDialogOpen && (
          <AddDescription
            getSiteDescriptions={() => console.log()}
            handleClose={() => {
              setAddDescriptionDialogOpen(false);
            }}
            addDescriptionDialogOpen={addDescriptionDialogOpen}
          />
        )}

        {/* 🎯 Timesheet Modals */}

        {timesheetAction === "view" && showTimesheetModal && (
          <TimesheetViewModal
            open={showTimesheetModal}
            onClose={() => setShowTimesheetModal(false)}
            seletetdTimesheet={selectedTimesheet}
            loginData={loginData}
            isSmallScreen={isSmallScreen}
            onEdit={(detail, timeSheetEnteries) => {
              console.log("Edit data received:", detail);
              // Switch to edit mode
              setTimesheetAction("add");
              setOperation("edit");
              setSelectedJob([...timeSheetEnteries]);
              setSelectedTimesheet({
                ...selectedTimesheet,
                ...detail, // Ensure we have the complete timesheet data
                id: selectedTimesheet?.id || detail?.id // Make sure ID is preserved
              });
              // Keep modal open for editing
            }}
            onSend={handleSendTimesheet}
            onPictureViewerOpen={(pictures, index) => {
              setImageArray(pictures);
              setImageIndex(index);
              setPictureViewer(true);
            }}
            onDeleteComplete={async (deletedTimesheet) => {
              console.log("Delete completed for:", deletedTimesheet); // ✅ ADD DEBUG
              await fetchDashboardData();
              setShowTimesheetModal(false);
              setSelectedTimesheet(null); // ✅ FIXED: Clear selected timesheet
            }}
          />
        )}

        {/* Clock In Modal */}
        <AddClockIn
          open={showClockInModal}
          onClose={() => setShowClockInModal(false)}
          seletetdClockInTimesheet={seletetdClockInTimesheet}
          operation={operation}
          selectedClockInJob={selectedClockInJob}
          setSelectedClokInJob={setSelectedClockInJob}
          loginData={loginData}
          goallist={goallist}
          isSmallScreen={isSmallScreen}
          onSaveComplete={handleTimesheetSaveComplete}
          onGoalModalOpen={() => {}} // No goal modal in dashboard
          onJoblistOpen={() => setShowJoblist(true)}
        />
        {timesheetAction === "add" && showTimesheetModal && (
          <AddEditTimesheetModel
            open={showTimesheetModal}
            onClose={() => setShowTimesheetModal(false)}
            operation={operation}
            initialUser={
              operation === "edit"
                ? selectedTimesheet // ✅ FIXED: Use selectedTimesheet for edit mode
                : {
                    timesheetDate: moment().format("YYYY-MM-DD"),
                    totalHours: "00:00",
                    isSent: false
                  }
            }
            selectedJob={selectedJob}
            setSelectedJob={setSelectedJob}
            loginData={loginData}
            goallist={goallist}
            userGoalData={userGoalData}
            onSaveComplete={handleTimesheetSaveComplete}
            onJoblistOpen={() => setShowJoblist(true)}
          />
        )}

        <SendTimesheet
          open={showSendTimesheet}
          onClose={() => setShowSendTimesheet(false)}
          selectedTimesheets={selectedTimesheetsToSend}
          loginData={loginData}
          onSendComplete={async () => {
            await fetchDashboardData();
            setShowTimesheetModal(false);
            setSelectedTimesheetsToSend([]);
            setShowSendTimesheet(false);
          }}
        />

        {/* Job Selection Modal */}
        <Joblist
          open={showJoblist}
          onClose={() => setShowJoblist(false)}
          loginData={loginData}
          selectedJob={selectedJob}
          setSelectedJob={setSelectedJob}
          selectedClockInJob={selectedClockInJob}
          setSelectedClokInJob={setSelectedClockInJob}
          isClockIn={showClockInModal}
          seletetdClockInTimesheet={seletetdClockInTimesheet}
          roleIndex={1}
        />

        {/* Picture Viewer */}
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => setPictureViewer(false)}
          pictures={imageArray.map((item, i) => ({
            src: item?.pictureUrl ? item?.pictureUrl : URL.createObjectURL(item)
          }))}
          viewerIndex={imageIndex}
        />

        {/* Timesheet Add Menu */}
        <Menu
          id="timesheet-menu"
          MenuListProps={{
            "aria-labelledby": "timesheet-menu-button"
          }}
          anchorEl={timesheetMenuAnchorEl}
          open={timesheetMenuOpen}
          onClose={handleTimesheetMenuClose}
          TransitionComponent={Fade}>
          <MenuItem onClick={handleClick}>
            <ListItem disablePadding>
              <ListItemButton>
                <AddCircleOutlineIcon sx={{ mr: 1 }} />
                <ListItemText primary={TEXT_NEW_TIMESHEET} />
              </ListItemButton>
            </ListItem>
          </MenuItem>
          <MenuItem onClick={handleClockInClick}>
            <ListItem disablePadding>
              <ListItemButton>
                <AccessTimeIcon sx={{ mr: 1 }} />
                <ListItemText primary={TEXT_ADD_CLOCKIN} />
              </ListItemButton>
            </ListItem>
          </MenuItem>
        </Menu>
      </Box>

      <Chatbot
        key={chatbotSessionKey}
        callAsk={callAsk}
        openChatbot={openChatbot}
        setOpenChatbot={setOpenChatbot}
        chatbotResponse={chatbotResponse}
        chatbotLoader={chatbotLoader}
        setChatbotResponse={setChatbotResponse}
        setChatbotLoader={setChatbotLoader}
        setQuestion={setQuestion}
        clearCurrentChatThread={clearCurrentChatThread}
        setCurrentChatHistoryId={updateCurrentChatHistoryId}
        normalizeChatbotHistoryRecord={normalizeChatbotHistoryRecord}
      />
    </>
  );
};

export default Home;
